import React, { useState, useEffect } from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase';

const Logout = () => {
  const handleLogout = async () => {
    await signOut(auth);
  };

  useEffect(() => {
    return () => handleLogout();
  }, []);

  return (
    <div>
      <h1>Logout avvenuto con successo!</h1>
    </div>
  );
};

export default Logout;